function showVideoPlayer() {
  const videoPlayerFrame = document.getElementById('video-player-frame')
  if (videoPlayerFrame) {
    videoPlayerFrame.classList.remove('hidden')
  }
}

function hideVideoPlayer() {
  const videoPlayerFrame = document.getElementById('video-player-frame')
  const videoIframe = document.getElementById('video-iframe')

  if (videoPlayerFrame) {
    videoPlayerFrame.classList.add('hidden')
  }

  if (videoIframe) {
    videoIframe.src = videoIframe.src
  }
}
